
import * as api from "../../../api"; 


  
export const getAllCourseThumbnails = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getAllCourseThumbnails(post);
        
        
        return data 
     } catch (error) {
        
    }
}

